import React, { useEffect, useState } from 'react';
import { useParams, NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { URL_COURTJUS_BACK, cle_COURTJUS } from '../constants/sources.js';
import { BIASSE_INIT } from '../constants/globals';
import { updateBiasse, insertBiasse, deleteBiasse } from '../actions/actions-types';
import Select from "react-select";
import { useAppContext } from '../AppContext';

const BiasseView = (props) => {
    const { userCJ } = useSelector(state => state);
    const dispatch = useDispatch();
    const { dispatch: contextDispatch } = useAppContext();

    const { postId } = useParams();
    const [biasseFiche, setBiasseFiche] = useState({}); // Initialisé à un objet vide
    const [producteurs, setProducteurs] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]); // Initialisé à un tableau vide
    const headers = new Headers();
    headers.append('cle', cle_COURTJUS);

    useEffect(() => {
        const list = [{ value: 0, label: "* Tous les producteurs *" }];
        fetch(`${URL_COURTJUS_BACK}/producteurs`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                res.forEach(element => {
                    list.push({ value: element.uNum, label: element.uStructure });
                });
                setProducteurs(list);
            });
    }, []);

    useEffect(() => {
        fetch(`${URL_COURTJUS_BACK}/biasse/${postId}`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(resb => {
                if (resb.length < 1) {
                    setBiasseFiche(BIASSE_INIT);
                } else {
                    let res = resb[0];
                    res.bDate = res.bDate.substring(0, 10);
                    res.bDateCdeIni = res.bDateCdeIni.substring(0, 10);
                    res.bDateCdeEnd = res.bDateCdeEnd.substring(0, 10);
                    setBiasseFiche(res);

                    const list = [];
                    fetch(`${URL_COURTJUS_BACK}/usersin/${res.bParticipants}`, {
                        method: 'GET',
                        headers: headers,
                    })
                        .then(response => response.json())
                        .then(resUsers => {
                            resUsers.forEach(producteur => { list.push({ value: producteur.uNum, label: producteur.uStructure }) });
                            setSelectedOptions(list);
                        });
                }
            });
    }, [postId]); // Ajout de la dépendance requise

    const handleChange = (event) => {
        const { name, value } = event.target;
        setBiasseFiche(oldFiche => { return { ...oldFiche, [name]: value, bMsg: "" }; });
    };

    const handleDownCB = (event) => {
        const { name, value } = event.target;
        let newValue = value === "true" ? false : true;
        setBiasseFiche(oldFiche => { return { ...oldFiche, [name]: newValue }; });
    };

    const handleUpCB = (event) => {
        setBiasseFiche(oldFiche => { return { ...oldFiche, bMsg: "" }; });
    };

    const handleChangeCB = () => { };

    function handleSelect(data) {
        const listB = [];
        const listSO = [];
        const tout = data.find(element => element.value === 0);

        if (tout) {
            producteurs.forEach(element => {
                if (element.value > 0) {
                    listB.push(element.value);
                    listSO.push({ value: element.value, label: element.label });
                }
            });
            setSelectedOptions(listSO);
        } else {
            data.forEach(element => {
                listB.push(element.value);
            });
            setSelectedOptions(data);
        }

        // On conserve bParticipants sous forme de TABLEAU temporairement en local
        setBiasseFiche(oldFiche => { return { ...oldFiche, bParticipants: listB, bMsg: "" }; });
    }

    function checkDate(inputDate) {
        var re = /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/;
        return re.test(inputDate);
    }

    function handleClickDel(event) {
        event.preventDefault();
        let errMsg = "";
        if (window.confirm("Voulez-vous réellement supprimer cette Biasse ?")) {
            errMsg = "suppression validée";
            dispatch(deleteBiasse({ biasseFiche }));
            setSelectedOptions([]);
            setBiasseFiche({
                bNum: 0,
                bLibelle: "",
                bComment: "",
                bDate: "",
                bDateCdeIni: "",
                bDateCdeEnd: "",
                bParticipants: "",
                bMsg: errMsg
            });
        } else {
            errMsg = "suppression annulée";
            setBiasseFiche(oldUser => { return { ...oldUser, bMsg: errMsg }; });
        }
    }

    const formatDateToFrench = (dateString) => {
        if (!dateString) return '';
        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
    };
    const formatDateToFrenchSmall = (dateString) => {
        if (!dateString) return '';
        const [year, month, day] = dateString.split('-');
        return `${day}/${month}`;
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        let errMsg = "";
        if (biasseFiche.bLibelle.length < 10) {
            errMsg = "Le libellé de la Biasse est trop court (10 car) !";
        }
        if (errMsg) {
            setBiasseFiche(oldUser => { return { ...oldUser, bMsg: errMsg }; });
            return;
        }

        // CORRECTION & SÉCURITÉ : Transformation des participants du format Tableau vers Texte séparé par virgules
        const participantsTexte = Array.isArray(biasseFiche.bParticipants)
            ? biasseFiche.bParticipants.join(',')
            : biasseFiche.bParticipants || "";

        const fichePourBackend = {
            ...biasseFiche,
            bParticipants: participantsTexte
        };

        if (biasseFiche.bNum === undefined || biasseFiche.bNum === 0) {
            dispatch(insertBiasse({ biasseFiche: fichePourBackend }));
            errMsg = "Biasse Ajoutée !";
            setBiasseFiche(oldUser => { return { ...oldUser, bParticipants: biasseFiche.bParticipants, bMsg: errMsg }; });
        } else {
            // "fichePourBackend" est maintenant parfaitement défini et typé en chaîne texte
            dispatch(updateBiasse({ biasseFiche: fichePourBackend }));
            errMsg = "Informations mises à jour !";
            setBiasseFiche(oldUser => { return { ...oldUser, bParticipants: biasseFiche.bParticipants, bMsg: errMsg }; });
        }

        const formattedDateB = formatDateToFrench(biasseFiche.bDate);
        const formattedDateCI = formatDateToFrenchSmall(biasseFiche.bDateCdeIni);
        const formattedDateCE = formatDateToFrenchSmall(biasseFiche.bDateCdeEnd);
        if (biasseFiche.bActif) {
            contextDispatch({ type: 'UPDATE_HEADER', payload: `${biasseFiche.bLibelle} : le ${formattedDateB} (commandes du ${formattedDateCI} au ${formattedDateCE})` });
        }
    };

    return (
        <main className="container">
            <div className="main-down"></div>
            {userCJ.uAdmin &&
                <>
                    {biasseFiche.bMsg && <section className="section-prods-err"><p>{biasseFiche.bMsg}</p></section>}
                    <section className="section-prods section-prods-form section-prods-col">
                        <form method="POST" id="formBiasse" encType="multipart/form-data" disabled={!userCJ.uAdmin} onSubmit={handleSubmit}>
                            <img src="/img/farmer_market.png" alt="Biasse" className="float-prods zone-tel-masque" />
                            <article className="section-prods-fiche form-fiche">
                                <fieldset disabled={!userCJ.uAdmin}>
                                    <legend>infos Biasse / marché <span className='span-light'>({biasseFiche.bNum})</span></legend>
                                    <p><label htmlFor="bLibelle">Nom</label> <input className="input-default" type="text" name="bLibelle" id="bLibelle" value={biasseFiche.bLibelle || ''} required onChange={handleChange} /></p>
                                    <p><label htmlFor="bDate">Date</label> <input className="input-default" type="date" name="bDate" id="bDate" value={biasseFiche.bDate || ''} required onChange={handleChange} /></p>
                                    <p><label htmlFor="bDateCdeIni">Debut des Cdes</label> <input className="input-default" type="date" name="bDateCdeIni" id="bDateCdeIni" value={biasseFiche.bDateCdeIni || ''} required onChange={handleChange} /></p>
                                    <p><label htmlFor="bDateCdeEnd">fin des Cdes</label> <input className="input-default" type="date" name="bDateCdeEnd" id="bDateCdeEnd" value={biasseFiche.bDateCdeEnd || ''} required onChange={handleChange} /></p>
                                    <p>
                                        <label className="check" htmlFor="bActif"> Actif</label>
                                        <input type="checkbox" id="bActif" name="bActif" checked={!!biasseFiche.bActif} value={biasseFiche.bActif || false} onMouseDown={handleDownCB} onMouseUp={handleUpCB} onChange={handleChangeCB} />
                                    </p>
                                </fieldset>
                            </article>
                            <article className="section-prods-infos form-fiche">
                                <fieldset disabled={!userCJ.uAdmin}>
                                    <legend>Producteurs presents</legend>
                                    <div className="dropdown-container">
                                        <p><Select
                                            options={producteurs}
                                            placeholder="Indentifiez les producteurs"
                                            value={selectedOptions}
                                            onChange={handleSelect}
                                            isSearchable={true}
                                            isMulti
                                        /></p>
                                    </div>
                                </fieldset>
                                <fieldset disabled={!userCJ.uAdmin}>
                                    <legend>Infos comp.</legend>
                                    <p><textarea className="input-area" name="bComment" id="bComment" onChange={handleChange} value={biasseFiche.bComment || ''} maxLength={1020}></textarea></p>
                                </fieldset>
                                <fieldset disabled={!userCJ.uAdmin} className="btn-detail">
                                    <legend>Actions</legend>
                                    <p><button id="fiche-sav" className='btn btn-primary'>Enregistrer</button>
                                        <NavLink to={`/biasses`} className='btn btn-secondary' aria-label="Retour à la liste des biasses" title="Retour à la liste des biasses">Fermer</NavLink></p>
                                </fieldset>
                            </article>
                            <section className="nav-admin"><p className="section-prods-err">{biasseFiche.bMsg}</p></section>
                            <section className="nav-admin"><p className="btn-detail"><img src="/img/delete.png" alt="supprimer la biasse" onClick={handleClickDel} /></p></section>
                        </form>
                    </section>
                    <div className="main-down"></div>
                </>
            }
            {userCJ.uAdmin === false &&
                <section className="section-prods"><p className="p-impact">Vous n'êtes pas autorisé à accéder à ces informations</p></section>
            }
        </main>
    );
};

export default BiasseView;